import { render, staticRenderFns } from "./FormTwilioNumber.vue?vue&type=template&id=2a5e89b4"
import script from "./FormTwilioNumber.vue?vue&type=script&lang=js"
export * from "./FormTwilioNumber.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./FormTwilioNumber.vue?vue&type=custom&index=0&blockType=docs"
if (typeof block0 === 'function') block0(component)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2a5e89b4')) {
      api.createRecord('2a5e89b4', component.options)
    } else {
      api.reload('2a5e89b4', component.options)
    }
    module.hot.accept("./FormTwilioNumber.vue?vue&type=template&id=2a5e89b4", function () {
      api.rerender('2a5e89b4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/candidates/components/FormTwilioNumber.vue"
export default component.exports